// ----------------------------------------------------------------------------
// jQuery
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import {$,jQuery} from "jquery";
